import React, { useState, useEffect } from "react"
import { graphql } from "gatsby"
import Engpro from "../components/totvs-news/engpro"
import CarolAssistant from "../components/addons/carol-assistant/avatar"
import GoogleAnalytics from "../components/addons/analytics"
import GoogleTagManagerHeader from "../components/addons/tag-manager-header"
import GoogleTagManagerBody from "../components/addons/tag-manager-body"
import ThemeChanger from "../components/addons/theme-changer"
import { Carousel } from "react-responsive-carousel"
import 'react-responsive-carousel/lib/styles/carousel.min.css'

// New Components
import Banner from "../components/shared/banner"
import Countdown from "../components/reforma/countdown"
import Checklist from "../components/reforma/checklist"
import LinkFooter from "../components/reforma/link-footer"
import Card from "../components/totvs-news/card"
import Panel from "../components/shared/panel"
import ViewSwitcher from "../components/shared/view-switcher"

const groupBy = (list, keyGetter) => {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}

const getResizedImg = (node, size) => {
    if (node.frontmatter === undefined) return '';
    let srcSet = node.frontmatter.featuredImage.childImageSharp.fluid.srcSet;
    let imgPath = srcSet.split(',').find(elem => elem.indexOf(size.toString()) !== -1).trim().split(' ')[0] || "";
    return imgPath || '';
}

const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
}

const checkValidDate = (item) => {
    let expDateString = item.frontmatter.expirationDate;
    if (!expDateString) return true;
    let expDate = new Date(expDateString);
    let datenow = new Date(Date.now());
    const diffTime = datenow - expDate;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 1;
}

export default ({ pageContext, data }) => {
    const banner = data.banner.nodes[0];
    const country = pageContext.country;
    const language = pageContext.language;
    
    let readMore;
    let newsHeader;
    let pnbuttonText;
    if (language === 'por') {
        readMore = 'Saiba mais';
        newsHeader = 'Comunicados Importantes'
        pnbuttonText = 'Clique aqui para conferir as novidades das rotinas'
    } else if (language === 'eng') {
        readMore = 'Read more';
        newsHeader = 'Important News'
        pnbuttonText = 'Click here to check the program news'
    } else if (language === 'spa') {
        readMore = 'Sepa mas';
        newsHeader = 'Anuncios Importantes'
        pnbuttonText = 'Haga clic aquí para ver las noticias sobre las rutinas'
    }
    
    const viewSwitcherURL = `https://totvsnews.engpro.totvs.io/${pageContext.moduleName}/${pageContext.country}/${pageContext.language}/images/${pageContext.moduleName}/`;

    const cards = data.cards.nodes.filter(card => checkValidDate(card));
    const links = data.links.nodes.filter(link => checkValidDate(link));
    const news = data.news.nodes.filter(newsItem => checkValidDate(newsItem));

    const engproBanner = data.engproBanner.nodes;

    let bannerFilter = engproBanner.filter(engproItem => {
        return (engproItem.frontmatter.showin && engproItem.frontmatter.showin.filter(x => x === pageContext.moduleName).length > 0) || (engproItem.frontmatter.showin === null || (engproItem.frontmatter.showin && engproItem.frontmatter.showin.length === 0));
    });

    //Getting all card content from markdown (localized)
    const cardTopBlue = cards.filter(x => x.frontmatter.type === 'card-top-blue')[0];
    const cardTopGray = cards.filter(x => x.frontmatter.type === 'card-top-gray')[0];
    const cardTopOrange = cards.filter(x => x.frontmatter.type === 'card-top-orange')[0];
    const cardBottomBlue = cards.filter(x => x.frontmatter.type === 'card-bottom-blue')[0];
    const cardBottomGray = cards.filter(x => x.frontmatter.type === 'card-bottom-gray')[0];
    const cardBottomOrange = cards.filter(x => x.frontmatter.type === 'card-bottom-orange')[0];

    const topCards = [cardTopBlue, cardTopGray, cardTopOrange].filter(item => item !== undefined);
    const bottomCards = [cardBottomBlue, cardBottomGray, cardBottomOrange].filter(item => item !== undefined);

    const groupedLinks = Array.from(groupBy(links, (item) => {
        if (item.frontmatter.category) return item.frontmatter.category
        else return ''
    }));

    const horizontalContainerConditionalJustifyTop = (cardTopBlue && cardTopGray && cardTopOrange) ? { "justify-content": "space-between" } : { "justify-content": "space-around" };
    const horizontalContainerConditionalJustifyBottom = (cardBottomBlue && cardBottomGray && cardBottomOrange) ? { "justify-content": "space-between" } : { "justify-content": "space-around" };

    // Modules that should use the default template
    const defaultTemplateModules = [
        'sigaexemplo',
        'sigaatf',
        'sigacom',
        'sigactb',
        'sigaest',
        'sigafat',
        'sigagct',
        'sigafin',
        'sigafis',
        'sigagfr',
        'sigagpe',
        'sigamdt',
        'sigamnt',
        'sigapco',
        'sigapcp',
        'sigasfc',
        // Add more module names here as needed
    ];

    const showTributePage = true;
    
    // Debug flag for development testing
    const debugForceChanges = false; // Set to true to test the changes
    const disableEngpro = false; // Set to true to disable Engpro carousel
    
    // Client-side date logic - runs in browser, not at build time
    const [isAfterJan1st2026, setIsAfterJan1st2026] = useState(false);
    const [isDateChecked, setIsDateChecked] = useState(false);
    
    useEffect(() => {
        // This runs in the browser after component mounts
        const currentDate = new Date();
        const targetDate = new Date('2026-01-05');
        const shouldShowNewContent = debugForceChanges || currentDate >= targetDate;
        
        setIsAfterJan1st2026(shouldShowNewContent);
        setIsDateChecked(true);
    }, [debugForceChanges]);

    return (
        <div className="main">
            <title>{`${pageContext.moduleName}-${country}-${language}`}</title>
            <GoogleTagManagerHeader />
            <GoogleTagManagerBody />
            <ThemeChanger />
            <script async src="https://www.googletagmanager.com/gtag/js?id=G-K14SPPV5EN"></script>
            <GoogleAnalytics module={pageContext.moduleName} />
            <link href="https://fonts.googleapis.com/css?family=Lato&display=swap" rel="stylesheet"></link>
            <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet"></link>
            {(defaultTemplateModules.includes(pageContext.moduleName) || (pageContext.country !== "bra" && pageContext.moduleName !== "sigafis")) && (
                <>
                    {banner && <Banner title={pageContext.moduleName} />}
                    <ViewSwitcher text={pnbuttonText} url={viewSwitcherURL}/>
                    {topCards.length > 0 && <div className="horizontal-container" style={horizontalContainerConditionalJustifyTop}>
                        {cardTopGray && <Card title={cardTopGray.frontmatter.title} color="gray" link={cardTopGray.frontmatter.link} cardTop={true}></Card>}
                        {cardTopBlue && <Card title={cardTopBlue.frontmatter.title} color="blue" link={cardTopBlue.frontmatter.link} cardTop={true}></Card>}
                        {cardTopOrange && <Card title={cardTopOrange.frontmatter.title} color="orange" link={cardTopOrange.frontmatter.link} cardTop={true}></Card>}
                    </div>}
                    {
                        !disableEngpro &&
                        <div className="engproArea" style={{"margin": "10px 0px"}}>
                            <Carousel
                                showThumbs={false}
                                infiniteLoop={true}
                                showIndicators={true}
                                showStatus={false}
                                autoPlay={true}
                                interval={5000}
                            >
                                {bannerFilter.filter(engproItem => checkValidDate(engproItem)).map(engproItem => {
                                    let engproBannerImg = (engproBanner !== undefined) ? getResizedImg(engproItem, engproItem.frontmatter.size) : undefined;
                                    return (
                                        <Engpro imgPath={engproBannerImg} title={engproItem.frontmatter.title} link={engproItem.frontmatter.link} width={engproItem.frontmatter.size} height={engproItem.frontmatter.height || "200"}>
                                            <div dangerouslySetInnerHTML={{ __html: engproItem.html }}></div>
                                        </Engpro>
                                    )
                                })}
                            </Carousel>
                        </div>
                    }
                    {news.length > 0 && <Panel title={newsHeader} className="news">
                        <ul>
                            {news.map(newsItem => (
                                <li key={`key${news.indexOf(newsItem)}`}>
                                    <div>
                                        <b>{newsItem.frontmatter.title}</b>
                                        <p>{newsItem.frontmatter.text}
                                            {newsItem.frontmatter.link && <> <a target="_placeholder" rel="noopener noreferrer" href={newsItem.frontmatter.link}>
                                                <u>{readMore}</u>
                                                <i className="material-icons">link</i>
                                            </a></>}
                                        </p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </Panel>}
                    {bottomCards.length > 0 && <div className="horizontal-container" style={horizontalContainerConditionalJustifyBottom}>
                        {cardBottomGray && <Card title={cardBottomGray.frontmatter.title} color="gray" link={cardBottomGray.frontmatter.link}>
                            <p>{cardBottomGray.frontmatter.text}</p>
                        </Card>}
                        {cardBottomBlue && <Card title={cardBottomBlue.frontmatter.title} color="blue" link={cardBottomBlue.frontmatter.link}>
                            <p>{cardBottomBlue.frontmatter.text}</p>
                        </Card>}
                        {cardBottomOrange && <Card title={cardBottomOrange.frontmatter.title} color="orange" link={cardBottomOrange.frontmatter.link}>
                            <p>{cardBottomOrange.frontmatter.text}</p>
                        </Card>}
                    </div>}
                    {links.length > 0 && <Panel title="Links" className="links">
                        {groupedLinks.length > 0 && groupedLinks.map(group => {
                            if (group[0] !== '') {
                                return (
                                    <div key={`key${getRandomInt(0, 10000)}`}>
                                        <b>{group[0]}</b>
                                        <ul>
                                            {group[1].map(link => (
                                                <li key={`key${getRandomInt(0, 10000)}`}>
                                                    {link.frontmatter.text}
                                                    {link.frontmatter.link && <> <a target="_placeholder" rel="noopener noreferrer" href={link.frontmatter.link}>
                                                        <u>{readMore}</u>
                                                        <i className="material-icons">link</i>
                                                    </a></>}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )
                            } else {
                                return (
                                    <ul>
                                        {group[1].map(link => (
                                            <li key={`key${getRandomInt(0, 10000)}`}>
                                                {link.frontmatter.text}
                                                <> <a target="_placeholder" rel="noopener noreferrer" href={link.frontmatter.link}>
                                                    <u>{readMore}</u>
                                                    <i className="material-icons">link</i>
                                                </a></>
                                            </li>
                                        ))}
                                    </ul>
                                )
                            }
                        }
                        )}</Panel>}
                    <CarolAssistant></CarolAssistant>
                </>
            )}
            {!defaultTemplateModules.includes(pageContext.moduleName) && (
                <div>
                    <Banner title={pageContext.moduleName} />
                    {isDateChecked ? (
                        <>
                            <Countdown isAfterJan1st2026={isAfterJan1st2026} />
                            <Checklist isAfterJan1st2026={isAfterJan1st2026} />
                        </>
                    ) : (
                        // Show default content while date is being checked to prevent hydration mismatch
                        <>
                            <Countdown isAfterJan1st2026={false} />
                            <Checklist isAfterJan1st2026={false} />
                        </>
                    )}
                    <LinkFooter />
                </div>
            )}
        </div>
    )
}

export const query = graphql`
query ($parentPath: String!, $languageRegex: String!, $countryRegex: String!) {
    engproBanner: allMarkdownRemark(filter: { fileAbsolutePath: {regex: "/engpro/"}, frontmatter: { type: {regex: "/banner/"}, country: {regex: $countryRegex}, language: {regex: $languageRegex}}}, sort: { fields: frontmatter___date, order: DESC }) {
        nodes {
            html
            excerpt
            frontmatter {
                title
                type
                size
                height
                link
                language
                country
                showin
                expirationDate
                featuredImage {
                    childImageSharp {
                      fluid(maxWidth: 1024, quality: 90) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                }
            }
        }
    }

    banner: allMarkdownRemark(filter: { fileAbsolutePath: {regex: $parentPath}, frontmatter: { type: {eq: "banner"}}} ) {
        nodes{
            html
            excerpt
            frontmatter {
              title
              type
              text
            }
            fileAbsolutePath  
        }
    },

    cards: allMarkdownRemark(filter: { fileAbsolutePath: {regex: $parentPath}, frontmatter: { type: {regex: "/card/"}}}) {
        nodes{
            html
            excerpt
            frontmatter {
              title
              type
              text
              link
              expirationDate
            }  
        }
    },

    links: allMarkdownRemark(filter: {fileAbsolutePath: {regex: $parentPath}, frontmatter: { type: {regex: "/link/"}}}, sort: { fields: frontmatter___date, order: DESC }) {
        nodes{
            html
            excerpt
            frontmatter {
              link
              type
              text
              link
              category
              date
              expirationDate
            }  
        }
    },

    news: allMarkdownRemark(filter: {fileAbsolutePath: {regex: $parentPath}, frontmatter: { type: {eq: "news"}}}, sort: { fields: frontmatter___date, order: DESC }) {
        nodes{
            html
            excerpt
            frontmatter {
              title
              text
              type
              link
              date
              expirationDate
            }  
        }
    },
  }
`